import { useEffect } from 'react';
import type { Lang } from './i18n';

type SeoArgs = {
  lang: Lang;
  title: string;
  desc: string;
};

/**
 * Sync <title>, meta description, og:title, og:description and <html lang>
 * whenever the language flips.
 */
export function useDocSeoSync({ lang, title, desc }: SeoArgs): void {
  useEffect(() => {
    document.title = title;
    const d = document.querySelector('meta[name="description"]');
    if (d) d.setAttribute('content', desc);
    const ogt = document.querySelector('meta[property="og:title"]');
    if (ogt) ogt.setAttribute('content', title);
    const ogd = document.querySelector('meta[property="og:description"]');
    if (ogd) ogd.setAttribute('content', desc);
    document.documentElement.lang = lang;
  }, [lang, title, desc]);
}
